import { render, staticRenderFns } from "./messageOverweigthModal.vue?vue&type=template&id=48d04067&scoped=true"
import script from "./messageOverweigthModal.vue?vue&type=script&lang=js"
export * from "./messageOverweigthModal.vue?vue&type=script&lang=js"
import style0 from "./messageOverweigthModal.vue?vue&type=style&index=0&id=48d04067&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d04067",
  null
  
)

export default component.exports